/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenu_user$ref = any;
export type SbRespRefineMenuSelector_user$ref = any;
export type SbRespRefineMenuSelector_user = {
    readonly " $fragmentRefs": SbRespRefineMenu_user$ref;
    readonly " $refType": SbRespRefineMenuSelector_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuSelector_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbRespRefineMenu_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ee7af77e836745da5513d2f7f4f23534';
export default node;
